import React from 'react';

const CookieNoticeLink = ({
  text,
  disabled,
  className,
  ...restProps
}) => (disabled ? (
  <span className={className}>{text}</span>
) : (
  <a className={className} rel="noopener noreferrer" {...restProps}>
    {text}
  </a>
));

export default CookieNoticeLink;
